import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Spinner,
} from "reactstrap";
import {
  createMenu,
  createMenuMult,
} from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { ptBR as pt } from "date-fns/locale";
import { AlertCircle, CheckCircle, Download } from "react-feather";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import moment from "moment";
import { Typography } from "@mui/material";
import AvatarGroup from "@mui/material/AvatarGroup";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { DataGrid, ptBR } from "@mui/x-data-grid";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

const token = process.env.REACT_APP_TOKEN_BLOB;

const theme = createTheme({
  palette: {
    primary: {
      main: "#007bff", // Altere a cor principal para a cor desejada
    },
    background: {
      default: "#f0f0f0", // Altere a cor de fundo padrão para a cor desejada
    },
  },
  components: {
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px", // Ajuste o espaçamento interno conforme necessário
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: 0,
          color: theme.palette.text.primary,
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
            {
              outline: "none",
            },
          "& .MuiDataGrid-panelWrapper": {
            maxWidth: "calc(100vw - 4rem)",
          },
        }),
        panelWrapper: {
          maxWidth: "98vw",
        },
        toolbarContainer: ({ theme }) => ({
          alignItems: "baseline",
          paddingRight: `${theme.spacing(6)} !important`,
          paddingLeft: `${theme.spacing(3.25)} !important`,
          "& .MuiDataGrid-panelWrapper": {
            maxWidth: "calc(100vw - 4rem)",
          },
        }),
        columnHeaders: ({ theme }) => ({
          backgroundColor: "#F6F6F7",
        }),
        columnHeader: ({ theme }) => ({
          "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
            paddingLeft: "10px",
            paddingRight: "10px",

            "&:first-of-type": {
              paddingLeft: "10px",
            },
          },
          "&:last-of-type": {
            paddingRight: "10px",
          },
        }),
        columnHeaderCheckbox: {
          maxWidth: "58px !important",
          minWidth: "58px !important",
        },
        columnHeaderTitleContainer: {
          padding: 0,
        },
        columnHeaderTitle: ({ theme }) => ({
          fontWeight: 600,
          letterSpacing: "1px",
          textTransform: "uppercase",
          fontSize: 12,
        }),
        columnSeparator: ({ theme }) => ({
          color: theme.palette.divider,
        }),
        row: {
          "&:last-child": {
            "& .MuiDataGrid-cell": {
              borderBottom: 0,
            },
          },
        },
        cell: ({ theme }) => ({
          borderColor: theme.palette.divider,
          "&:not(.MuiDataGrid-cellCheckbox)": {
            paddingLeft: "10px",
            paddingRight: "10px",
            "&:first-of-type": {
              paddingLeft: "10px",
            },
          },
          "&:last-of-type": {
            paddingRight: "10px",
          },
          "&:focus, &:focus-within": {
            outline: "none",
          },
        }),
        cellCheckbox: {
          maxWidth: "58px !important",
          minWidth: "58px !important",
        },
        editInputCell: ({ theme }) => ({
          padding: 0,
          color: theme.palette.text.primary,
          "& .MuiInputBase-input": {
            padding: 0,
          },
        }),
        footerContainer: ({ theme }) => ({
          alignItems: "baseline",
          borderTop: `1px solid ${theme.palette.divider}`,
          "& .MuiTablePagination-toolbar": {
            alignItems: "baseline",
            paddingLeft: `${theme.spacing(4)} !important`,
            paddingRight: `${theme.spacing(4)} !important`,
          },
          "& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel":
            {
              color: theme.palette.text.primary,
            },
        }),
        selectedRowCount: ({ theme }) => ({
          display: "none",
          margin: 0,
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
        }),
      },
    },
  },
});

let millisecondsPerDay = 24 * 60 * 60 * 1000; // Milissegundos por dia
let referenceDate = new Date("1899-12-30"); // Data de referência do Excel

const CadastrarEventoExcel = (props) => {
  // ** Const
  const columns = [
    {
      minWidth: 130,
      field: "actions",
      headerName: "Status",
      filterable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="d-flex cursor-pointer">
          {!row.Status ? (
            <div title="Pending"></div>
          ) : row.Status === "Success" ? (
            <div title="Created">
              <CheckCircle color="green" />
            </div>
          ) : row.Status === "Sent" ? (
            <Spinner className="border-spinner" color="info" />
          ) : (
            <div title={row.StatusMessage}>
              <AlertCircle color="red" />
            </div>
          )}
        </div>
      ),
    },
    {
      field: "id",
      headerName: "ID",
      minWidth: 200,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ color: "text.primary", fontSize: "12px" }}
        >
          {params.row.id}
        </Typography>
      ),
    },
    {
      flex: 1,
      field: "title",
      headerName: "Título",
      minWidth: 240,
      renderCell: (params) => (
        <Typography
          variant="body2"
          title={params.row.title}
          sx={{
            color: "text.primary",
            fontSize: "12px",
            fontWeight: "bold",
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {params.row.title}
        </Typography>
      ),
    },
    {
      field: "startDateTime",
      headerName: "Início",
      width: 110,
      type: "date",
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => (
        <React.Fragment>
          {!params.row.allDay ? (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.startDateTime).format("DD/MM/YYYY HH:mm")}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.startDateTime).format("DD/MM/YYYY")} Dia todo
            </Typography>
          )}
        </React.Fragment>
      ),
    },
    {
      field: "endDateTime",
      headerName: "Término",
      width: 110,
      type: "date",
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => (
        <React.Fragment>
          {!params.row.allDay ? (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.endDateTime).format("DD/MM/YYYY HH:mm")}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              sx={{ color: "text.primary", fontSize: "12px" }}
            >
              {moment(params.row.endDateTime).format("DD/MM/YYYY")} Dia todo
            </Typography>
          )}
        </React.Fragment>
      ),
    },
    {
      field: "location",
      headerName: "Localização",
      minWidth: 140,
      renderCell: (params) => (
        <div
          title={params.row.location}
          style={{
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 12,
          }}
        >
          {params.row.location}
        </div>
      ),
    },
    {
      flex: 1,
      field: "description",
      headerName: "Descrição",
      minWidth: 220,
      renderCell: (params) => (
        <div
          title={params.row.description}
          style={{
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 12,
          }}
        >
          {params.row.description}
        </div>
      ),
    },
    {
      field: "notifications",
      headerName: "Notificações",
      minWidth: 160,
      renderCell: (params) => (
        <div
          style={{
            maxHeight: "30px",
            overflow: "auto",
            whiteSpace: "pre-line",
            fontSize: 12,
          }}
        >
          {params.row.notifications.map((item) => (
            <div>
              {" "}
              {item.time} {item.typeUnit} - {item.type}{" "}
            </div>
          ))}
        </div>
      ),
    },
    {
      field: "guests",
      headerName: "Convidados",
      minWidth: 140,
      //valueGetter: (params) => params.value.join(", "),
      renderCell: ({ row }) => (
        <AvatarGroup max={6}>
          {row.guests?.map((email, index) => (
            <Tooltip key={index} title={email} arrow>
              <Avatar
                sx={{ bgcolor: "#007bff", width: 22, height: 22, fontSize: 12 }}
              >
                {email.substring(0, 2)}
              </Avatar>
            </Tooltip>
          ))}
        </AvatarGroup>
      ),
    },
  ];
  // ** Props
  const { open, setOpen } = props;
  const [data, setData] = useState([]);

  useEffect(() => {
    registerLocale("pt-BR", pt);
    setDefaultLocale("pt-BR");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: ".xlsx, .xls",
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length) {
        const reader = new FileReader();
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result;
          var workbook = XLSX.read(binaryStr, {
            type: "array",
          });

          workbook.SheetNames.forEach(function (sheetName) {
            // Here is your object
            var rows = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[sheetName]
            );
            setData(
              rows.map((item) => {
                item.endDateTime = new Date(
                  referenceDate.getTime() +
                    item.endDateTime * millisecondsPerDay
                );
                item.startDateTime = new Date(
                  referenceDate.getTime() +
                    item.startDateTime * millisecondsPerDay
                );
                item.startDateTime.setHours(item.startDateTime.getHours() + 3);
                item.endDateTime.setHours(item.endDateTime.getHours() + 3);
                item.notifications = item.notifications
                  ? JSON.parse(item.notifications)
                  : [];

                item.guests = item.guests
                  ? item.guests?.replace(/\s/g, "").split(",")
                  : "";

                // eslint-disable-next-line eqeqeq
                item.allDay = String(item.allDay).toLowerCase() == "true";

                item.uuid = uuidv4();

                return item;
              })
            );
          });
        };
        reader.readAsArrayBuffer(acceptedFiles[0]);
      } else {
        //toast.error("Select only files with a .pbix or .pdf extension!");
      }
    },
  });

  const downloadTemplate = () => {
    let link = document.createElement("a");
    link.download = "template-importar-eventos";
    link.href =
      "https://devlnxstorage.blob.core.windows.net/abs-storage/template-importar-eventos.xlsx" +
      token;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async () => {
    // eslint-disable-next-line array-callback-return
    await Promise.all(
      data.map(async (item, index) => {
        data[index].Status = "Sent";
        data[index].startDateTime = moment(data[index].startDateTime).format(
          "YYYY-MM-DDTHH:mm"
        );
        data[index].endDateTime = moment(data[index].endDateTime).format(
          "YYYY-MM-DDTHH:mm"
        );
        setData([...data]);

        await fetch(
          `${process.env.REACT_APP_BACKEND_URL}${
            data[index].id ? "update-event" : "create-event"
          }`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
              //Authorization: "bearer " + token,
            }),
            body: JSON.stringify(item),
          }
        )
          .then(function (response) {
            if (response.status === 200) {
              response.json().then(function (resp) {
                data[index].Status = "Success";
                setData([...data]);
              });
            } else {
              data[index].Status = "Error";
              setData([...data]);
            }
          })
          .catch(function (error) {
            data[index].Status = "Error";
            setData([...data]);
          });
      })
    );
    props.handleGetEvents();
    //setOpen(false);
    toast.success("Eventos importados com sucesso");
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="xl"
      backdrop="static"
      style={{maxWidth:'100%'}}
    >
      <ModalHeader
        toggle={() => {
          setOpen(!open);
          setData([]);
          props.setRefresh(true);
          props.setOpen(false);
        }}
      >
        Cadastrar Eventos{" "}
      </ModalHeader>
      <ModalBody>
        {data?.length === 0 ? (
          <div>
            <div className="text-end">
              <Button onClick={() => downloadTemplate()}>
                <Download size={15} />
                <span className="align-middle" style={{ marginLeft: 8 }}>
                  Downaload Template
                </span>
              </Button>
            </div>
            <FormGroup>
              <div
                style={{ border: "2px dashed #00a1f1", background: "#f8f8f8" }}
                {...getRootProps({
                  className: `dropzone py-4 flex-column`,
                })}
              >
                <input {...getInputProps()} />
                <div className="text-center">
                  <i className="nc-icon nc-cloud-download-93" />
                  <div className="mb-0 mt-1 mx-2 import-file">
                    Arraste o arquivo ou clique aqui
                  </div>
                </div>
              </div>
            </FormGroup>
          </div>
        ) : (
          <ThemeProvider theme={theme}>
            {/* <div style={gridStyle}> */}
            <div style={{ height: 500 }}>
              <DataGrid
                initialState={{
                  sorting: {
                    sortModel: [{ field: "startDateTime", sort: "asc" }],
                  },
                }}
                rowHeight={30}
                rows={data}
                columns={columns}
                //pageSizeOptions={[7, 10, 25, 50]}
                //paginationModel={paginationModel}
                //slots={{ toolbar: SearchToolbar }}
                //onPaginationModelChange={setPaginationModel}
                //rows={filteredData.length ? filteredData : data}
                //pagination
                hideFooter
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: "1.125rem",
                  },
                }}
                slotProps={{
                  baseButton: {
                    size: "medium",
                    variant: "outlined",
                  },
                }}
                getRowId={(row) => row?.uuid}
                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
              />
              {/* </div> */}
            </div>
          </ThemeProvider>
        )}
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit()} color="primary">
          Cadastrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    publish: state.screening.screening.publish,
    menuNew: state.screening.screening.menuNew,
    editMenu: state.screening.screening.editMenu,
    menu: state.screening.screening.menu,
    //e/rror: state.screening.screening.error,
    //loading: state.screening.screening.loading,
  };
};

export default connect(mapStateToProps, {
  createMenu,
  createMenuMult,
})(CadastrarEventoExcel);
